// 关于我们
<template>
  <div class="main">
    <div class="banana">
      <img src="../assets/img/banner/画板 3.png" alt />
    </div>
    <div class="center">
      <div class="nav">
        <p>
          当前位置：
          <span @click="shouye" class="navvv">首页</span> > 关于我们
        </p>
      </div>
      <h1>
        <span class="blue"></span>公司概况
        <span class="blueone"></span>
      </h1>
      <div class="gsgk">
        <div class="leftImg"></div>
        <div class="rightMsg">
          <p>河南建协工程咨询有限公司是一家提供建筑行业全过程咨询服务的企业。经营范围包括工程项目创优咨询、企业管理咨询服务、工程管理服务、信息技术咨询服务、基础软件服务、应用软件服务、互联网数据服务、财务信息咨询、税务信息咨询、培训、会议及展览服务。</p>
          <p>河南建协工程咨询有限公司凭借在建筑业领域积累的深厚行业经验、精深专业能力和对国内外成功建筑类企业深入研究的基础上，组建了一支理论功底深厚、专业素质强、实践经验丰富的专家团队，涉及到企业管理、财务分析、信息化建设、工程建造、法律法务等多学科、多领域专家数百人。通过整合省内外建筑领域关键资源和核心能力，建立了一套科学合理、行之有效的咨询服务体系。</p>
          <p>公司业务范围重点涉及质量全面提升过程咨询、专项培训、项目信息化建设、法律服务咨询等六大板块。为企业制定中长期发展规划、改良组织架构、优化业务流程、转变发展模式、培育新型产业、提供创优策划、提升技术质量安全管理水平、实施品牌战略等方面提供富有创意和经济有效的咨询服务，使客户获得可持续发展的竞争优势。</p>
          <p>公司以服务客户为中心，以专业诊断、科学指导、有效施策、过程提升为宗旨，以塑造精品、培养人才、锻炼队伍、总结经验、提炼标准为经营方针，为建筑企业高质量可持续发展赋能，致力于将公司打造成为一家具有竞争力、省内领先的全过程工程咨询服务型企业。</p>
        </div>
      </div>
      <h1 class="yw">
        <span class="blue"></span>业务领域
        <span class="blueone"></span>
      </h1>
      <ul class="xiangqing">
        <li class="xiangqingList">
          <div class="left">
            <h2 class="xiangqingTitle">工程项目质量全面提升过程咨询</h2>
            <p class="xiangqingMsg">
              以工程项目为服务对象，以鲁班奖创建为目标，通过了解项目基本情况、匹配专家、拟定咨询建议书，
              四次现场和若干次在线和现场节点咨询，为客户提供技术、质量、安全、绿色施工、科技创新、管理提升等全过程技术支持，帮助客户强化质量意识、改善管理、完善工艺，持续改进、过程提升、一次成优。
            </p>
            <div class="more" @click="project">查看更多+</div>
          </div>
          <div class="right">
            <img src="../assets/img/首页/38c2c01a33c38ab63f9f44b1e087eb7a@2x.png" class="main_img" />
          </div>
        </li>
        <li class="xiangqingList">
          <div class="right">
            <img src="../assets/img/首页/5316a45cf639d6ff1456aaf6463895ff.png" class="main_img" />
          </div>
          <div class="left">
            <h2 class="xiangqingTitle">专项培训</h2>
            <div class="zxpx">
              <span class="blue"></span>工程项目培训
            </div>
            <div class="zxpx">
              <span class="blue"></span>行业前沿技术培训
            </div>
            <div class="more onemore" @click="train">查看更多+</div>
          </div>
        </li>
        <li class="xiangqingList">
          <div class="left">
            <h2 class="xiangqingTitle">项目信息化建设</h2>
            <p class="xiangqingMsg">
              以工程项目为服务对象，通过云计算、大数据、物联网、人工智能、移动智能终端和5G等信息技术，为企业
              提供投标展示方案、图纸会审、工程量的统计、施工模拟、可视化交底、施工节点分析、综合管线碰撞检测、建筑物全生命周期信息化模型等BIM、智慧工地方面的咨询服务。
            </p>
            <div class="more" @click="information">查看更多+</div>
          </div>
          <div class="right">
            <img src="../assets/img/首页/1b05e1d5fd56182e60c301d30381fba4.png" class="main_img" />
          </div>
        </li>
        <li class="xiangqingList">
          <div class="right">
            <img src="../assets/img/首页/3e6632e4465e4d017df985598d87376f.png" class="main_img" />
          </div>
          <div class="left">
            <h2 class="xiangqingTitle">法律服务咨询</h2>
            <p
              class="xiangqingMsg"
            >根据建筑行业发展动态，针对工程招投标、合同谈判与签订，项目实施过程中诸如工期、质量、造价、担保、保险、损害赔偿、工伤、劳务纠纷等方面的问题，为客户提供专业化法律咨询服务。同时，也可为客户提供企业并购、对外投资合作、公司治理等方面的服务咨询。</p>
            <div class="more" @click="law">查看更多+</div>
          </div>
        </li>
        <li class="xiangqingList">
          <div class="left">
            <h2 class="xiangqingTitle">双重预防体系咨询服务</h2>
            <p
              class="xiangqingMsg"
            >包括安全评估及认证服务，双重预防体系实施，双重预防体系建设咨询、双重预防体系建设培训、双重预防体系平台建设以及不同行业、特殊环境双体系定制开发等内容。 指导企业建立组织机构、完善工作制度，建立健全档案管理制度，风险点排查确定，危险源识别、分析，风险评价，制定风险管控措施；隐患分级与分类，重大隐患治理。</p>
            <div class="more" @click="double">查看更多+</div>
          </div>
          <div class="right">
            <img src="../assets/img/首页/6.png" class="main_img" />
          </div>
        </li>
        <li class="xiangqingList">
          <div class="right">
            <img src="../assets/img/首页/luban2.png" class="main_img" />
          </div>
          <div class="left">
            <h2 class="xiangqingTitle">项目汇报视频、PPT材料服务</h2>
            <p
              class="xiangqingMsg"
            >由专业团队驻现场进行项目考察、拍摄、素材采集，针对项目优点、难点进行重点刻画表现，以及根据甲方提供图片、视频及文字材料，进行工法申报材料的制作。</p>
            <div class="more" @click="items">查看更多+</div>
          </div>
        </li>
      </ul>
    </div>
    <!-- <div class="tx">
        <div class="bottOne"></div>
        <div class="bottTwo"></div>
        <div class="bottThree"></div>
        <div class="bottFour"></div>
        <div class="bottFive"></div>
        <div class="bottSix"></div>
    </div>-->
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  methods: {
    project() {
      this.$router.replace("/project");
    },
    train() {
      this.$router.replace("/train");
    },
    information() {
      this.$router.replace("/information");
    },
    law() {
      this.$router.replace("/law");
    },
    double() {
      this.$router.replace("/double");
    },
    items() {
      this.$router.replace("/items");
    },
    shouye() {
      this.$router.replace("/");
    },
    aboutour() {
      this.$router.replace("/aboutour");
    },
  },
  components: {},
};
</script>

<style scoped lang="less">
@import "../assets/css/index";
@import '../assets/css/media/indexMedia';
.main {
  width: 100%;
  font-size: 16px;
  .banana {
    width: 100%;
    img {
      width: 100%;
      height: 100%;
    }
    // background: url("../assets/img/banner/画板 3.png") center no-repeat;
    // background-size: cover;
  }
  .center {
    width: 1160px;
    // padding: 0px 360px
    margin: 0 auto;
    box-sizing: border-box;
    overflow: hidden;
    .nav {
      width: 100%;
      border-bottom: 1px solid #a0a0a0;
      opacity: 1;
      font-size: 12px;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      font-weight: 400;
      text-align: justifyLeft;
      color: #666666;
      line-height: 36px;
      margin-bottom: 50px;
    }
    h1 {
      width: 150px;
      height: 29px;
      margin: 50px auto;
      position: relative;
      text-align: center;
      font-size: 30px;
      span {
        display: block;
        width: 14px;
        height: 14px;
        background: url("../assets/img/icon/blue.png") center no-repeat;
        background-size: cover;
        position: absolute;
      }
      .blue {
        top: 16px;
        left: -20px;
      }
      .blueone {
        top: 16px;
        right: -20px;
      }
    }
    .gsgk {
      width: 100%;
      height: 430px;
      margin-bottom: 30px;
      display: flex;
      justify-content: space-between;
      .leftImg {
        width: 447px;
        height: 385px;
        opacity: 1;
        background: url("../assets/img/首页/aboutOurTop.jpg") center no-repeat;
        background-size: cover;
      }
      .rightMsg {
        width: 661px;
        height: 380px;
        p {
          margin: 0;
          opacity: 1;
          font-size: 14px;
          font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
          font-weight: 400;
          text-align: justifyLeft;
          color: #333333;
          line-height: 21px;
          margin-bottom: 20px;
          text-indent: 2em;
        }
      }
    }
    //   .tx{
    //       width: 100%;
    //       height: 4.71px;
    //       display: flex;
    //       justify-content: center;
    //       align-items: center;
    //       div{
    //           width: 16.66%;
    //           height: 100%;
    //       }
    //       .bottOne{

    //       }
    //       .bottTwo{

    //       }
    //       .bottThree{

    //       }
    //       .bottFour{

    //       }
    //       .bottFive{

    //       }
    //       .bottSix{

    //       }
    //   }
  }
}
.more:hover {
  cursor: pointer;
}
</style>
